<div *ngIf="isCompType" class="ttmodal">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Add Component Type</span>
      <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>
  <div class="ttmodal__body">
      <div class="input-container margin-bottom-16">
        <!-- <span class="label">Component Type</span>
        <input type="text" [(ngModel)]="compType" placeholder="Enter component type" /> -->

        <mat-form-field style="width: 100%">
          <input matInput id="compType_" placeholder="Enter component type" type="text" [(ngModel)]="compType"
              ngDefaultControl  >
      </mat-form-field>
    </div>
  </div>
  <div class="ttmodal__footer">
      <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
      <a class="button button--primary" [class.loading]="savingChanges" (click)="saveChanges()"><span class="button__text">Save</span></a>
  </div>
</div>

<div *ngIf="isImpType" class="ttmodal" >
  <div class="ttmodal__header">
      <span class="ttmodal__title">Add Asset Definition</span>
      <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>
  <div class="ttmodal__body">
      <!-- <div class="input-container margin-bottom-16">
        <span class="label">Implement Type</span>
        <input type="text" [(ngModel)]="NewimplementType" placeholder="Enter Implement type" />
    </div> -->

    <mat-form-field style="width: 100%">
      <input matInput id="NewimplementType_" placeholder="Enter Asset Definition" type="text" [(ngModel)]="NewimplementType"
          ngDefaultControl  >
  </mat-form-field>
  </div>
  <div class="ttmodal__footer">
      <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
      <a class="button button--primary" [class.loading]="savingChanges" (click)="saveChanges()"><span class="button__text">Save</span></a>
  </div>
</div>

<div *ngIf="isImplement" class="ttmodal">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Edit Implement Serial</span>
      <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>
  <div class="ttmodal__body">
      <!-- <div class="input-container margin-bottom-16">
        <span class="label">Implement Serial</span>
        <input type="text" [(ngModel)]="implementSerial" placeholder="Enter Implement Serial" />
    </div> -->
    <mat-form-field style="width: 100%">
      <input matInput id="implementSerial" placeholder="Enter Implement Serial" type="text" [(ngModel)]="implementSerial"
          ngDefaultControl  >
  </mat-form-field>
  </div>
  <div class="ttmodal__footer">
      <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
      <a class="button button--primary" [class.loading]="savingChanges" (click)="saveChanges()"><span class="button__text">Save</span></a>
  </div>
</div>